import { IDynamicEventHandler } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { Action } from '@ngrx/store';

export type IDynamicEventHandlerWithId = IDynamicEventHandler & { id?: string };

export function eventHandlerFromAction<T extends Action>(
  action: T,
  options?: Partial<
    Pick<IDynamicEventHandler, 'payload$' | 'payloadFetchMoment'>
  > & { id?: string },
): IDynamicEventHandlerWithId {
  const eventHandler: IDynamicEventHandlerWithId = {
    type: 'ngrx',
    action: action.type,
  };

  if (options?.payload$ !== undefined) {
    eventHandler.payload$ = options.payload$;
  } else {
    const payloadObj: Partial<T> = {
      ...action,
    };
    delete payloadObj.type;
    if (Object.keys(payloadObj).length > 0) {
      eventHandler.payload$ = payloadObj;
    }
  }

  if (options?.payloadFetchMoment !== undefined) {
    eventHandler.payloadFetchMoment = options.payloadFetchMoment;
  }

  if (options?.id !== undefined) {
    eventHandler.id = options.id;
  }

  return eventHandler;
}
